import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appDnd]',
    exportAs: 'appDnd'
})
export class DndDirective {
    @HostBinding('class.fileover') fileOver: boolean;
    @Output() fileDropped = new EventEmitter<any>();
    @Input() isDialog: boolean;

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt): void {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
        if (this.isDialog) {
            this.elemRef.nativeElement.parentElement.parentElement.classList.add('fileover');
        }
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt): void {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        if (this.isDialog) {
            this.elemRef.nativeElement.parentElement.parentElement.classList.remove('fileover');
        }
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt): void {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        if (this.isDialog) {
            this.elemRef.nativeElement.parentElement.parentElement.classList.remove('fileover');
        }
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
        }
    }

    constructor(private elemRef: ElementRef) {
        this.elemRef = elemRef;
    }
}
